import { Button } from '@/components/ui/button';
import useServicesCategoriesTable from '@/hooks/table/useServicesCategoriesTable';
import { PlusIcon } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ErrorMessage from '../../error-message/ErrorMessage';
import TableColumnsToggle from '../../table-columns-toggle/TableColumnsToggle';
import { GenericTable } from '../common/generic-table/GenericTable';
import TableSearchInput from '../common/table-search-input/TableSearchInput';

const ServicesCategoriesTable: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    table,
    filtering,
    setFiltering,
    emptyData,
    featureFlagCrudValue,
    isLoading,
    isError
  } = useServicesCategoriesTable();

  if (isError) {
    return <ErrorMessage />;
  }

  return (
    <>
      <div
        className={`flex items-center gap-2 py-4 ${featureFlagCrudValue ? 'justify-between' : 'justify-end'}`}
      >
        {featureFlagCrudValue && (
          <Button
            onClick={() => navigate('./create')}
            className="flex items-center gap-2"
          >
            <PlusIcon className="w-5" />
            <p>{t('form.create')}</p>
          </Button>
        )}
        <div className="flex items-center gap-2">
          <TableSearchInput
            value={filtering ?? ''}
            onChange={(event) => {
              setFiltering(event.target.value);
            }}
          />
          <TableColumnsToggle disabled={emptyData} table={table} />
        </div>
      </div>
      <GenericTable table={table} isLoading={isLoading} />
    </>
  );
};

export default ServicesCategoriesTable;
